import './TitlesSkeleton.scss';

const TitlesSkeleton = ({ 
    hideSubtitle = false,
    hidePrimarySubtitle = false 
}) => {
    return (
        <div className='titles__section__skeleton'>
            <div className='titles__wrapper__skeleton'>
                <div className='titles__wrapper__title__skeleton'></div>
                {!hideSubtitle && (
                    <div className='titles__wrapper__subtitle__skeleton'></div>
                )}
                {!hidePrimarySubtitle && (
                    <div className='titles__wrapper__subtitle__skeleton--primary'></div>
                )}
            </div>
        </div>
    );
};

export default TitlesSkeleton;